/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WeeklySelectionIndexRouteImport } from './routes/weekly-selection/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as RecipesIndexRouteImport } from './routes/recipes/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as MenuIndexRouteImport } from './routes/menu/index'
import { Route as MealsIndexRouteImport } from './routes/meals/index'
import { Route as AvailabilityIndexRouteImport } from './routes/availability/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as MenuEditRouteImport } from './routes/menu/edit'
import { Route as MenuComposeRouteImport } from './routes/menu/compose'
import { Route as MealsNewRouteImport } from './routes/meals/new'
import { Route as MealsEnrichRouteImport } from './routes/meals/enrich'
import { Route as MealsMealIdRouteImport } from './routes/meals/$mealId'
import { Route as MealsMealIdEditRouteImport } from './routes/meals/$mealId_.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeeklySelectionIndexRoute = WeeklySelectionIndexRouteImport.update({
  id: '/weekly-selection/',
  path: '/weekly-selection/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIndexRoute = RecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/menu/',
  path: '/menu/',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsIndexRoute = MealsIndexRouteImport.update({
  id: '/meals/',
  path: '/meals/',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityIndexRoute = AvailabilityIndexRouteImport.update({
  id: '/availability/',
  path: '/availability/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuEditRoute = MenuEditRouteImport.update({
  id: '/menu/edit',
  path: '/menu/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuComposeRoute = MenuComposeRouteImport.update({
  id: '/menu/compose',
  path: '/menu/compose',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsNewRoute = MealsNewRouteImport.update({
  id: '/meals/new',
  path: '/meals/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsEnrichRoute = MealsEnrichRouteImport.update({
  id: '/meals/enrich',
  path: '/meals/enrich',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsMealIdRoute = MealsMealIdRouteImport.update({
  id: '/meals/$mealId',
  path: '/meals/$mealId',
  getParentRoute: () => rootRouteImport,
} as any)
const MealsMealIdEditRoute = MealsMealIdEditRouteImport.update({
  id: '/meals/$mealId_/edit',
  path: '/meals/$mealId/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meals/$mealId': typeof MealsMealIdRoute
  '/meals/enrich': typeof MealsEnrichRoute
  '/meals/new': typeof MealsNewRoute
  '/menu/compose': typeof MenuComposeRoute
  '/menu/edit': typeof MenuEditRoute
  '/users/$id': typeof UsersIdRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/meals/': typeof MealsIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/weekly-selection/': typeof WeeklySelectionIndexRoute
  '/meals/$mealId/edit': typeof MealsMealIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meals/$mealId': typeof MealsMealIdRoute
  '/meals/enrich': typeof MealsEnrichRoute
  '/meals/new': typeof MealsNewRoute
  '/menu/compose': typeof MenuComposeRoute
  '/menu/edit': typeof MenuEditRoute
  '/users/$id': typeof UsersIdRoute
  '/availability': typeof AvailabilityIndexRoute
  '/meals': typeof MealsIndexRoute
  '/menu': typeof MenuIndexRoute
  '/products': typeof ProductsIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/recipes': typeof RecipesIndexRoute
  '/users': typeof UsersIndexRoute
  '/weekly-selection': typeof WeeklySelectionIndexRoute
  '/meals/$mealId/edit': typeof MealsMealIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/meals/$mealId': typeof MealsMealIdRoute
  '/meals/enrich': typeof MealsEnrichRoute
  '/meals/new': typeof MealsNewRoute
  '/menu/compose': typeof MenuComposeRoute
  '/menu/edit': typeof MenuEditRoute
  '/users/$id': typeof UsersIdRoute
  '/availability/': typeof AvailabilityIndexRoute
  '/meals/': typeof MealsIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/weekly-selection/': typeof WeeklySelectionIndexRoute
  '/meals/$mealId_/edit': typeof MealsMealIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/meals/$mealId'
    | '/meals/enrich'
    | '/meals/new'
    | '/menu/compose'
    | '/menu/edit'
    | '/users/$id'
    | '/availability/'
    | '/meals/'
    | '/menu/'
    | '/products/'
    | '/profile/'
    | '/recipes/'
    | '/users/'
    | '/weekly-selection/'
    | '/meals/$mealId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/meals/$mealId'
    | '/meals/enrich'
    | '/meals/new'
    | '/menu/compose'
    | '/menu/edit'
    | '/users/$id'
    | '/availability'
    | '/meals'
    | '/menu'
    | '/products'
    | '/profile'
    | '/recipes'
    | '/users'
    | '/weekly-selection'
    | '/meals/$mealId/edit'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/meals/$mealId'
    | '/meals/enrich'
    | '/meals/new'
    | '/menu/compose'
    | '/menu/edit'
    | '/users/$id'
    | '/availability/'
    | '/meals/'
    | '/menu/'
    | '/products/'
    | '/profile/'
    | '/recipes/'
    | '/users/'
    | '/weekly-selection/'
    | '/meals/$mealId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  MealsMealIdRoute: typeof MealsMealIdRoute
  MealsEnrichRoute: typeof MealsEnrichRoute
  MealsNewRoute: typeof MealsNewRoute
  MenuComposeRoute: typeof MenuComposeRoute
  MenuEditRoute: typeof MenuEditRoute
  UsersIdRoute: typeof UsersIdRoute
  AvailabilityIndexRoute: typeof AvailabilityIndexRoute
  MealsIndexRoute: typeof MealsIndexRoute
  MenuIndexRoute: typeof MenuIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  RecipesIndexRoute: typeof RecipesIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  WeeklySelectionIndexRoute: typeof WeeklySelectionIndexRoute
  MealsMealIdEditRoute: typeof MealsMealIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weekly-selection/': {
      id: '/weekly-selection/'
      path: '/weekly-selection'
      fullPath: '/weekly-selection/'
      preLoaderRoute: typeof WeeklySelectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/': {
      id: '/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof RecipesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/': {
      id: '/menu/'
      path: '/menu'
      fullPath: '/menu/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals/': {
      id: '/meals/'
      path: '/meals'
      fullPath: '/meals/'
      preLoaderRoute: typeof MealsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability/': {
      id: '/availability/'
      path: '/availability'
      fullPath: '/availability/'
      preLoaderRoute: typeof AvailabilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/edit': {
      id: '/menu/edit'
      path: '/menu/edit'
      fullPath: '/menu/edit'
      preLoaderRoute: typeof MenuEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/compose': {
      id: '/menu/compose'
      path: '/menu/compose'
      fullPath: '/menu/compose'
      preLoaderRoute: typeof MenuComposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals/new': {
      id: '/meals/new'
      path: '/meals/new'
      fullPath: '/meals/new'
      preLoaderRoute: typeof MealsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals/enrich': {
      id: '/meals/enrich'
      path: '/meals/enrich'
      fullPath: '/meals/enrich'
      preLoaderRoute: typeof MealsEnrichRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals/$mealId': {
      id: '/meals/$mealId'
      path: '/meals/$mealId'
      fullPath: '/meals/$mealId'
      preLoaderRoute: typeof MealsMealIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meals/$mealId_/edit': {
      id: '/meals/$mealId_/edit'
      path: '/meals/$mealId/edit'
      fullPath: '/meals/$mealId/edit'
      preLoaderRoute: typeof MealsMealIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  MealsMealIdRoute: MealsMealIdRoute,
  MealsEnrichRoute: MealsEnrichRoute,
  MealsNewRoute: MealsNewRoute,
  MenuComposeRoute: MenuComposeRoute,
  MenuEditRoute: MenuEditRoute,
  UsersIdRoute: UsersIdRoute,
  AvailabilityIndexRoute: AvailabilityIndexRoute,
  MealsIndexRoute: MealsIndexRoute,
  MenuIndexRoute: MenuIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  RecipesIndexRoute: RecipesIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  WeeklySelectionIndexRoute: WeeklySelectionIndexRoute,
  MealsMealIdEditRoute: MealsMealIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
